if (!customElements.get('save-for-later')) {
  customElements.define(
    'save-for-later',
    class SaveForLater extends HTMLElement {
      constructor() {
        super();
        this.products = null;
        this.itemCount = 0;
        this.boundClickListener = this.onClickListener.bind(this); // bind only once and save the reference
      }

      connectedCallback() {
        this.products = JSON.parse(localStorage.getItem("savedForLater") || '[]');
        if (window.location.href.includes('/cart')) this.classList.add('cart-template');
        this.init();
      }
      
      onClickListener(e) {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
          quantity,
          productHandle,
          variantId,
          itemKey,
          size
        } = clickedElement.dataset;
        
        switch (action) {
          case 'save-for-later':
            this.products.push({ productHandle, variantId, quantity, size });
            this.products = [...new Set(this.products)];
            localStorage.setItem("savedForLater", JSON.stringify(this.products));
            
            window.dispatchEvent(new CustomEvent('cart:removeItem', { detail: { itemKey } }));
          break;
          
          case 'remove-from-saved':
            document.querySelector('mini-cart')?.classList.add('loading');
            this.products = this.products.filter(
              (product) => product.variantId !== variantId
            );              
            
            localStorage.setItem("savedForLater", JSON.stringify(this.products));
            this.innerHTML = ``;
            // This is the result of a safari rendering bug
            // It will force the repainting of the parent element 
            const parent = this.closest('.save-for-later-wrapper');
            if (parent) {
              parent.style.display= 'none';
              parent.offsetHeight; // no need to store this anywhere, the reference is enough
              parent.style.display= null;
            }
            this.populateSavedProducts();
            document.querySelector('mini-cart')?.classList.remove('loading');
          break;
          default: break;
        }
      }
      
      disconnectedCallback() {
        document.removeEventListener('click', this.boundClickListener);
      }
      
      init() {
        document.addEventListener('click', this.boundClickListener);
        
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((response) => response.json())
          .then((data) => {
            // Loop through cart items and check if any are present in this.products
            this.products = this.products.filter((savedProduct) => {
              const inCart = data.items.some((cartItem) => 
                cartItem.variant_id == savedProduct.variantId ||
                cartItem.handle == savedProduct.productHandle
              );
              
              return !inCart;
            });
      
            localStorage.setItem("savedForLater", JSON.stringify(this.products));
      
            this.populateSavedProducts();
          })
          .catch((error) => {
            console.error(`Failed to fetch cart:`, error);
            this.innerHTML = ``;
          });
      }
      
      populateSavedProducts() {
        const productPromises = this.products.map(async (product) => {
          const productUrl = `${window.Shopify.routes.root}products/${product.productHandle}.json`;
          return fetch(productUrl)
              .then((response) => {
                  if (response.status === 404) {
                      console.warn(`Product not found: ${product.productHandle}`);
                      return null;
                  }
                  if (!response.ok) {
                      console.error(`Error fetching product: ${response.status}`);
                      return null;
                  }
                  return response.json();
              })
              .then((data) => {
                  if (!data) return null;
                  return { ...data.product, ...product };
              })
              .catch((error) => {
                  console.error(`Failed to fetch product ${product.productHandle}:`, error.message || error);
                  return null;
              });
          });
      
      
        Promise.all(productPromises)
          .then((productDataArray) => {
            if (!productDataArray.length || !productDataArray.find(({ variantId }) => variantId)) {
              this.innerHTML = ``;
              return;
            }
            
            this.itemCount = 0;
            
            let productSlides = ``;
            productDataArray
              .filter(item => item?.quantity && item?.variantId)
              .forEach((productData) => {
                if (!productData.quantity) return;
                this.itemCount += Number(productData.quantity);
                productSlides += (`
                  <swiper-slide>
                    <form class="flex flex-col h-full w-full gap-2" method="post" action="/cart/add" id="product_form_${productData.id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">
                      <img class="block w-full object-cover object-center" src="${productData.image.src}" width="100" height="100" /> 
                      <span class="text-sm capitalize">
                        ${productData.title.split(' - ')[0]}
                      </span>
                      <div class="flex flex-col mt-auto">
                        <span class="text-xs capitalize">
                          Size: <strong class="font-medium whitespace-nowrap">${productData.size}</strong>
                        </span>
                        <span class="text-xs capitalize">
                          Color: <strong class="font-medium whitespace-nowrap">${productData.title.split(' - ')[1]}</strong>
                        </span>
                        <span class="text-xs capitalize mt-auto">
                          Quantity: <strong class="font-medium whitespace-nowrap">${productData.quantity || 1}</strong>
                        </span>
                      </div>
                      <input type="hidden" name="form_type" value="product" />
                      <input class="" type="hidden" name="quantity" min="1" value="${productData.quantity || 1}">
                      <input type="hidden" name="form_type" value="product" />
                      <input type="hidden" name="utf8" value="✓" />
                      <input data-form-property="" type="hidden" name="properties[Size]" value="${productData.size}">
                      <input type="hidden" name="id" value="${productData.variantId}" />
                      <input type="hidden" name="product-id" value="${productData.id}" />
                      <div class="flex flex-col w-full gap-2 pt-2 md:pt-0 md:gap-0 align-start md:align-center">
                        <button class="button-primary button-sm w-full px-0.5">Add to Cart</button>
                        <button data-variant-id="${productData.variantId}" type="button" data-action="remove-from-saved" class="button-link button-sm text-xs md:w-full px-0.5">Remove</button>
                      </div>
                    </form>
                  </swiper-slide>
                `);
              });
            
            document.querySelectorAll('[data-saved-count]').forEach(x => x.innerText = `(${this.itemCount})`);            
            this.innerHTML = `
              <div class="relative z-[1]">
              ${window.location.href.includes('/cart') ? `
               <button 
                id="data-swiper-prev-saved-alt"  
                class="hidden md:!flex justify-center z-10 absolute top-[77px] left-0 bg-secondaryLight w-8 h-6 max-w-8 max-h-6 min-w-8 min-h-6 items-center disabled:opacity-0 transition [&_svg]:origin-center [&_svg]:transform [&_svg]:scale-x-[-1]"
                >
                  <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M6.75 3.75L12 9L6.75 14.25" stroke="#1C1C1C" stroke-width="2" stroke-linecap="square"/>
                  </svg>
                </button>
                <button 
                  id="data-swiper-next-saved-alt"  
                  class="hidden md:!flex justify-center z-10 absolute top-[77px] right-0 bg-secondaryLight w-8 h-6 max-w-8 max-h-8 min-w-6 min-h-6 items-center disabled:opacity-0 transition"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M6.75 3.75L12 9L6.75 14.25" stroke="#1C1C1C" stroke-width="2" stroke-linecap="square"/>
                  </svg>
                </button>
                ` : ''}
                <button 
                  id="data-swiper-prev-saved"  
                  class="${window.location.href.includes('/cart') ? 'md:hidden' : '' } justify-center z-10 absolute top-[77px] left-0 bg-secondaryLight w-8 h-6 max-w-8 max-h-6 min-w-8 min-h-6 flex items-center disabled:opacity-0 transition [&_svg]:origin-center [&_svg]:transform [&_svg]:scale-x-[-1]"
                >
                  <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M6.75 3.75L12 9L6.75 14.25" stroke="#1C1C1C" stroke-width="2" stroke-linecap="square"/>
                  </svg>
                </button>
                <button 
                  id="data-swiper-next-saved"  
                  class="${window.location.href.includes('/cart') ? 'md:hidden' : '' } justify-center z-10 absolute top-[77px] right-0 bg-secondaryLight w-8 h-6 max-w-8 max-h-8 min-w-6 min-h-6 flex items-center disabled:opacity-0 transition"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M6.75 3.75L12 9L6.75 14.25" stroke="#1C1C1C" stroke-width="2" stroke-linecap="square"/>
                  </svg>
                </button>
                <swiper-container 
                  space-between="4" 
                  slides-per-view="${window.location.href.includes('/cart') ? 1.7 : 3}"
                  navigation="true"
                  navigation-next-el="#data-swiper-next-saved"
                  navigation-prev-el="#data-swiper-prev-saved"
                  class="${window.location.href.includes('/cart') ? 'md:hidden' : ''}"
                  role="region"
                  aria-label="Save for later carousel"
                  watch-slides-progress="true"
                >
                  ${productSlides}
                </swiper-container>
                ${window.location.href.includes('/cart') ? `
                  <swiper-container 
                    space-between="4" 
                    slides-per-view="5"
                    navigation="true"
                    navigation-next-el="#data-swiper-next-saved-alt"
                    navigation-prev-el="#data-swiper-prev-saved-alt"
                    class="${window.location.href.includes('/cart') ? 'hidden md:!block' : ''}"
                    role="region"
                    aria-label="Save for later carousel"
                    watch-slides-progress="true"
                  >
                    ${productSlides}
                  </swiper-container>
                ` : ''}
              </div>
            `;
            
                       
            // This is the result of a safari rendering bug
            // It will force the repainting of the parent element 
            const parent = this.closest('.save-for-later-wrapper');
            if (parent) {
              parent.style.display= 'none';
              parent.offsetHeight; // no need to store this anywhere, the reference is enough
              parent.style.display= null;
            }
          })
          .catch((error) => {
            this.innerHTML = ``;
            console.error('Error fetching products:', error);
          });
      }      
  });
}